import { Cache } from 'three/src/loaders/Cache.js';
import { Loader } from 'three/src/loaders/Loader.js';
import IndexDB from '../../utils/indexdb';

const db = new IndexDB('texture');
class ImageBitmapLoader extends Loader {
  resolves = [];
  initDB = false;
  constructor(manager) {
    super(manager);

    if (typeof createImageBitmap === 'undefined') {
      console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
    }

    if (typeof fetch === 'undefined') {
      console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
    }
    db.close();
    db.initIndexDB(() => {
      this.initDB = true;
      this.resolves.forEach((r) => r());
    });
    this.options = { premultiplyAlpha: 'none' };
  }

  setOptions(options) {
    this.options = options;

    return this;
  }

  getBlob(base64) {
    // 获取头部信息
    let base64Arr = base64.split(',');
    let base64Str = base64Arr[0];
    let type = base64Str.substring(base64Str.indexOf(':'), base64Str.indexOf(';'));
    // 转换为类型化数组
    let bytes = Buffer.from(base64Arr[1], 'base64');
    return new Blob([bytes], { type });
  }

  async load(url, onLoad, onProgress, onError) {
    if (!this.initDB) {
      await new Promise((resolve) => {
        this.resolves.push(resolve);
      });
    }
    if (url === undefined) url = '';

    if (this.path !== undefined) url = this.path + url;

    url = this.manager.resolveURL(url);

    const scope = this;

    const cached = Cache.get(url);

    if (cached !== undefined) {
      scope.manager.itemStart(url);

      setTimeout(function () {
        if (onLoad) onLoad(cached);

        scope.manager.itemEnd(url);
      }, 0);

      return cached;
    }

    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
    fetchOptions.headers = this.requestHeader;
    const blobCache = await db.getData(url);
    const hasTextureCache = sessionStorage.getItem('hasTextureCache') || false;
    new Promise((resolve, reject) => {
      if (!blobCache?.target?.result)
        fetch(url, fetchOptions)
          .then(function (res) {
            const blob = res.blob();
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      else resolve(this.getBlob(blobCache.target.result.base64));
    })
      .then(function (blob) {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
          !blobCache?.target?.result && db.setData(url, { base64: e.target.result, url });
          !hasTextureCache && sessionStorage.setItem('hasTextureCache', true);
        };
        return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: 'none' }));
      })
      .then(function (imageBitmap) {
        Cache.add(url, imageBitmap);

        if (onLoad) onLoad(imageBitmap);

        scope.manager.itemEnd(url);
      })
      .catch(function (e) {
        if (onError) onError(e);

        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      });

    scope.manager.itemStart(url);
  }
}

ImageBitmapLoader.prototype.isImageBitmapLoader = true;

export { ImageBitmapLoader };
